import { updateMiembro } from '../../api/miembros/updateMiembro';
import createApiModule from '../createApiModule';
import { t } from '../../i18n';

const updateMiembroModule = createApiModule({
  name: 'updateMiembro',
  apiMethod: updateMiembro,
  onSuccess: (user) => ({
    message: t('StoreUsuarioModificado', {
      nombre: user.nombre,
      apellido1: user.apellido1,
      apellido2: user.apellido2,
    }),
    path: '/miembros',
  }),
  onError: () => ({
    message: t('StoreMiembrosUpdateMiembroModuleErrorAlModificarElMiembroA'),
  }),
  onValidationError: () => ({
    message: 'Error al modficar el miembro/a',
  }),
});

export const {
  start: update,
  success: updateOk,
  error: updateKo,
} = updateMiembroModule.slice.actions;

export default updateMiembroModule;
